{
  "moreActions": "Veel toiminguid",
  "unavailable": "Pole kättesaadav, üksikasjade vaatamiseks laiendage"
}
